import { Box } from '@material-ui/core';
import { CounterMinusIcon, CounterPlusIcon } from './SvgIcons';

interface IShoppingCartItemCounter {
  total: number;
  disableAddButton?: boolean;
  handleClickIncrease: () => void;
  handleClickDecrease: () => void;
}

const ShoppingCartItemCounter: React.FC<IShoppingCartItemCounter> = ({
  total,
  disableAddButton,
  handleClickIncrease,
  handleClickDecrease,
}) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    height={16}
    width={70}
    style={{ gap: '16px', border: '1px solid #71717A', borderRadius: '4px' }}
  >
    <Box
      onClick={handleClickDecrease}
      display="flex"
      padding="6px 3px"
      style={{ cursor: 'pointer' }}
      data-testid="shopping-cart-item-counter-decrease-button"
    >
      {CounterMinusIcon}
    </Box>
    <Box fontSize={10}>{total}</Box>
    <Box
      display="flex"
      padding="6px 3px"
      onClick={handleClickIncrease}
      style={{
        cursor: 'pointer',
        pointerEvents: disableAddButton ? 'none' : 'auto',
      }}
      data-testid="shopping-cart-item-counter-increase-button"
    >
      {CounterPlusIcon}
    </Box>
  </Box>
);

export default ShoppingCartItemCounter;
